import script from "./Filmlibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./Filmlibrary.vue?vue&type=script&setup=true&lang=js"

import "./Filmlibrary.vue?vue&type=style&index=0&id=9ae8f4c0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ae8f4c0"]])

export default __exports__